












import Vue from 'vue';
import { Icon } from '@/components/ds';

export default Vue.extend({
  components: {
    Icon,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    showCloseButton: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit('closeModal');
    },
  },
});
